import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface BillingDetailsProps {
  recipientName?: string;
  address?: string;
  city?: string;
  postCode?: string;
  country?: string;
  vat?: string;
  isVatUe?: boolean;
}

export const BillingDetails = types.model({
  recipientName: types.maybe(types.string),
  address: types.maybe(types.string),
  city: types.maybe(types.string),
  postCode: types.maybe(types.string),
  country: types.maybe(types.string),
  vat: types.maybe(types.string),
  isVatUe: types.maybe(types.boolean),
});

export type BillingDetailsSnapshot = SnapshotIn<typeof BillingDetails>;
export type BillingDetailsInstance = Instance<typeof BillingDetails>;
